import { createIconComponent } from '../../factory/create-icon-component';
export const AlignLeftIcon = createIconComponent(
  'AlignLeftIcon',
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M21 6H17H13H3M3 12H11M3 18H16"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
    />
  </svg>,
);
